<template>
  <widget
    :header="widgetData.header"
    :color="widgetData.headerColor"
    closable
    @close="$emit('close')"
  >
    <div class="click-to-text-widget-completed__content">
      <widget-icon
        name="check_circle_outline"
        :size="isMobile ? '80px' : '100px'"
        class="mb-1 success--text"
      />

      <div class="click-to-text-widget-completed__title">
        {{ widgetData.completedTitle }}
      </div>

      <div class="body-text-semi-bold-14 distinct--text lh-20 break-word">
        {{ widgetData.completedDescription }}
      </div>
    </div>
  </widget>
</template>

<script lang="ts">
import WidgetIcon from '@widgets/shared/components/WidgetIcon.vue'
import Widget from '@widgets/shared/components/Widget.vue'
import type { PropType } from '@/composition/vue/compositionApi'
import { defineComponent } from '@/composition/vue/compositionApi'
import { useBreakpoints } from '@/composition/breakpoints'
import type { ClickToTextForm } from '@/services/domain/services/forms/clickToText/types'

export default defineComponent({
  components: {
    WidgetIcon,
    Widget,
  },
  props: {
    widgetData: {
      type: Object as PropType<ClickToTextForm>,
      required: true,
    },
  },
  emits: {
    close: () => true,
  },
  setup() {
    const { isMobile } = useBreakpoints()

    return {
      isMobile,
    }
  },
})
</script>

<style lang="scss" scoped>
.click-to-text-widget-completed {
  &__content {
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    text-align: center;
    align-items: center;
    padding: 0 12px;
    justify-content: center;
    height: 100%;

    @include media-sm-max {
      padding: 0 8px;
    }
  }

  &__title {
    font-size: $xxl-font;
    font-weight: $bold-font;
    color: $neutral;
    line-height: 38px;
    margin-bottom: 16px;
    word-break: break-word;

    @include media-sm-max {
      font-size: $xl-font;
      line-height: 30px;
      margin-bottom: 14px;
    }
  }
}
</style>
